enum WidgetType {
    TABS = 'Tabs',
    MULTIGRAPH = 'MultiGraphs',
    BARS = 'Bars',
    CARDS = 'Cards',
    LISTS = 'Lists'
}

export default WidgetType;